export class RawDataFilterSettingsModel {
  public name: string;
  public number: string;
  public authorisationStatusId?: number;
  public rawDataStatusId?: number;
  public dataSourceTypeId?: number;
}